export const PURCHASE_STATE = 'purchase'

export const SAVE_CUSTOMER_DATA = 'SAVE_CUSTOMER_DATA'
export const SAVE_HOLDERS = 'SAVE_HOLDERS'
export const SAVE_INSURANCE_IDS = 'SAVE_INSURANCE_IDS'
export const SAVE_ADDITIONAL_DATA = 'SAVE_ADDITIONAL_DATA'

export const CLEAN_CUSTOMER_DATA = 'CLEAN_CUSTOMER_DATA'
